module.exports = __webpack_public_path__ + "static/media/AlgorithmDropDown.1b496f3d.png";